<template>
    <div class="dropdown-block">
        <label> {{ label }}
            <!-- information icon-->
            <item-icon :information="information"> </item-icon>
        </label>

        <!--Input-->
        <codd-toggle
                :val="val"
                @codd_input="onInputChange">

        </codd-toggle>
    </div>
</template>

<script>
    import ItemIcon from '../../input/InformationIcon'
    import CoddToggle from '../../input/Toggle'

    export default {
        name: 'MenuItemToggle',
        props: {
            label: {
                default: 'Placeholder label'
            },
            val: {
                default: ['First', 'Second']
            },
            information: {
                default: 'informatie over dit'
            },
        },
        data() {
            return {
                ownValue: this.val,
            }
        },
        components: {
            ItemIcon,
            CoddToggle,
        },
        methods: {
            onInputChange(val){
                this.$emit('onChange', val)
            }
        }
    }
</script>

<style scoped lang="scss">


</style>